<template>

  <div class="py-4 container-fluid">
    <div class="row">


      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2">
              <p class="mb-0">Crear Producto</p>
              <div class="d-flex align-items-center gap-2 ms-auto">
                <button
                  v-if="form.id != 0"
                  type="button"
                  class="btn btn-outline-primary btn-sm mb-0"
                  @click="generatePdf"
                >
                  <i class="fa fa-file-pdf me-1"></i> Generar PDF
                </button>
                <argon-button
                  v-if="form.status != 1 && ((user.role !== '1' && form.status == 0) || user.role === '1')"
                  color="success"
                  size="sm"
                  @click="save"
                >Guardar como borrador</argon-button>
                <argon-button
                  v-if="(user.role !== '1' && form.status == 0) || (user.role === '1' && form.status == 0 && form.id != 0)"
                  color="warning"
                  size="sm"
                  @click="confirm"
                >Formalizar</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label"
                  >Proveedor</label>
                <div class="d-flex gap-2 supplier-select-row">
                  <select
                    ref="supplierSelect"
                    class="form-select flex-grow-1"
                    v-model="form.supplier_id"
                    @change="selectSupplier"
                    :disabled="form.status == 1"
                  >
                    <option value="">Seleccione un proveedor</option>
                    <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">
                      {{ formatSupplierLabel(supplier) }}
                    </option>
                  </select>
                  <argon-button v-if="form.status != 1" color="success" size="sm" @click="openAddSupplierModal"><i class="fa fa-user-plus"></i></argon-button>
              </div>
              </div>
              <div class="col-md-12">
                <label for="purchase-description" class="form-control-label">Descripción</label>
                <textarea
                  id="purchase-description"
                  v-model="form.description"
                  class="form-control"
                  rows="3"
                  placeholder="Descripción opcional de la compra"
                  :disabled="form.status == 1"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="form.id!=0">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="text-uppercase mb-0 me-auto">Lista de compras</p>
              <div
                v-if="form.status != 1 && ((user.role === '1') || (user.role !== '1' && form.status == 0))"
                class="d-flex align-items-center gap-2 ms-auto"
              >
                <argon-button
                  color="info"
                  size="sm"
                  title="Agregar producto al inventario"
                  @click="openQuickInventoryModal"
                >
                  <i class="fa fa-plus"></i>
                </argon-button>
                <argon-button color="success" size="sm" @click="openModal">
                  Agregar compra
                </argon-button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >Cantidad (Und - Mts)</th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >Precio Unidad</th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >Total</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center" v-if="(user.role!=='1' && form.status===0) || user.role==='1'"   >
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.inventory.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.quantity }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat( value.price ).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat( value.total_price ).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ new Date(value.updated_at).toLocaleDateString('es-ES') }} 
                        </span>
                      </td>
                      
                      <td class="align-middle text-center" v-if="(user.role!=='1' && form.status===0) || user.role==='1'"  >
                        <a
                          @click="editDetail(value)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          data-original-title="Editar registro"
                        >
                          <i class="fa fa-pencil-alt"></i>
                        </a>
                        <a
                          @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                          data-toggle="tooltip"
                          data-original-title="Eliminar registro"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-3" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Modo de pago</p>
              <argon-button
                color="success"
                size="sm"
                class="ms-auto"
                @click="addPayment"
              >
                Agregar pago
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Forma de pago</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Valor pagado</th>
                    <th
                      v-if="form.status != 1"
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                    >
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="payment in paymentsData" :key="payment.id">
                    <td class="align-middle text-center text-sm">
                      {{ payment.payment_method }}
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatMoney(payment.amount_pagado) }}
                      </span>
                    </td>
                    <td v-if="form.status != 1" class="align-middle text-center">
                      <a
                        @click="editPayment(payment)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                      >
                        <i class="fa fa-pencil-alt"></i>
                      </a>
                      <a
                        @click="deletePayment(payment.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!paymentsData.length">
                    <td :colspan="form.status != 1 ? 3 : 2" class="text-center text-muted text-sm py-4">
                      No hay pagos registrados.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3 g-3">
              <div class="col-md-4">
                <div class="payment-summary-card">
                  <p class="text-sm mb-0 text-secondary">Total compra</p>
                  <p class="text-sm font-weight-bold mb-0">{{ formatMoney(purchaseTotal) }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="payment-summary-card">
                  <p class="text-sm mb-0 text-secondary">Total pagado</p>
                  <p class="text-sm font-weight-bold mb-0">{{ formatMoney(totalPagado) }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="payment-summary-card"
                  :class="diferenciaPendiente <= 0 ? 'payment-summary-card--paid' : 'payment-summary-card--pending'"
                >
                  <p class="text-sm mb-0 text-secondary">Diferencia pendiente</p>
                  <p class="text-sm font-weight-bold mb-0">{{ formatMoney(diferenciaPendiente) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  <!-- Modal agregar pago -->
  <div class="modal fade" id="ModalPurchasePayment" tabindex="-1" aria-labelledby="purchasePaymentModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="purchasePaymentModalLabel">{{ paymentModal.id ? 'Editar pago' : 'Agregar pago' }}</h5>
          <button type="button" class="btn-close" @click="closePaymentModal"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label class="form-label">Forma de pago</label>
              <select v-model="paymentModal.payment_method" class="form-select">
                <option value="">Seleccione forma de pago</option>
                <option v-for="method in paymentMethods" :key="method" :value="method">
                  {{ method }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Valor pagado</label>
              <input
                type="text"
                inputmode="decimal"
                v-model="formattedPaymentPagado"
                class="form-control"
                placeholder="0,00"
              >
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closePaymentModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitPayment">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Asignar tecnico -->
  <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ purchase.id ? 'Editar compra' : 'Agregar compra' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label for="amount" class="form-label">Insumo</label>
              <select v-model="purchase.inventory_id" ref="processesSelect" id="processes" class="form-select select2" style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} ({{ process.ref }})
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="amount" class="form-label">Cantidad (Und - Mts)</label>
              <input
                type="text"
                inputmode="numeric"
                :value="purchase.quantity ? purchase.quantity : ''"
                id="purchase_quantity"
                class="form-control"
                placeholder="Ingrese cantidad entera"
                @input="onPurchaseQuantityInput"
              >
            </div>
            <div class="mb-3">
              <label for="purchase_unit_price" class="form-label">Precio Unidad</label>
              <input
                type="text"
                inputmode="decimal"
                id="purchase_unit_price"
                class="form-control"
                placeholder="0,00"
                :value="formatCurrencyInput(purchase.price)"
                @input="onPurchasePriceInput"
              >
            </div>
            <div class="mb-3">
              <label for="purchase_line_total" class="form-label">Total</label>
              <input
                type="text"
                inputmode="decimal"
                id="purchase_line_total"
                class="form-control"
                placeholder="0,00"
                :value="formatCurrencyInput(purchase.total_price)"
                @input="onPurchaseTotalInput"
              >
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal agregar producto rápido al inventario -->
  <div class="modal fade" id="ModalQuickInventory" tabindex="-1" aria-labelledby="quickInventoryModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="quickInventoryModalLabel">Agregar producto al inventario</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="quick-product-name" class="form-label">Nombre *</label>
              <input
                id="quick-product-name"
                type="text"
                v-model="newQuickProduct.name"
                class="form-control"
                placeholder="Nombre del producto"
              >
            </div>
            <div class="mb-3">
              <label for="quick-product-ref" class="form-label">Referencia *</label>
              <input
                id="quick-product-ref"
                type="text"
                v-model="newQuickProduct.ref"
                class="form-control"
                placeholder="SKU o referencia"
              >
            </div>
            <div class="mb-3">
              <label for="quick-product-price" class="form-label">Precio de compra</label>
              <input
                id="quick-product-price"
                type="text"
                inputmode="decimal"
                v-model="formattedQuickProductPrice"
                class="form-control"
                placeholder="0,00"
              >
            </div>
            <div class="mb-3">
              <label for="quick-product-sale-price" class="form-label">Precio de venta</label>
              <input
                id="quick-product-sale-price"
                type="text"
                inputmode="decimal"
                v-model="formattedQuickProductSalePrice"
                class="form-control"
                placeholder="0,00"
              >
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeQuickInventoryModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="saveQuickProduct">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Agregar Proveedor -->
  <div class="modal fade" id="ModalAddSupplier" tabindex="-1" aria-labelledby="addSupplierModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="addSupplierModalLabel">Agregar Proveedor</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="supplier-name" class="form-label">Nombre *</label>
              <input type="text" v-model="newSupplier.name" id="supplier-name" class="form-control" placeholder="Ingrese el nombre" required>
            </div>
            <div class="mb-3">
              <label for="supplier-email" class="form-label">Email</label>
              <input type="email" v-model="newSupplier.email" id="supplier-email" class="form-control" placeholder="Opcional">
            </div>
            <div class="mb-3">
              <label for="supplier-phone" class="form-label">Teléfono</label>
              <input type="text" v-model="newSupplier.phone" id="supplier-phone" class="form-control" placeholder="Opcional">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeAddSupplierModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="saveSupplier">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</div>


  
</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
//import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import userService from '../../../services/user.service';
import { formatCurrencyInput, parseCurrencyInput } from '../../../helpers/currencyInput';

const body = document.getElementsByTagName("body")[0];

export default {
name: "Models Create",
data() {
  return {
    showMenu: false,
    modalBudget:null,
    modalPayment: null,
    paymentsData: [],
    paymentMethods: [
      'NEQUI',
      'DAVIPLATA',
      'DATAFONO',
      'EFECTIVO',
      'CREDITO',
      'TRANSFERENCIA',
    ],
    paymentModal: {
      id: 0,
      purchase_id: 0,
      payment_method: '',
      amount_pagado: 0,
    },
    isFinish:false,
    user:{},
    form: {
      id:0,
      supplier_id: '',
      supplier: '',
      phone: '',
      email: '',
      description: '',
      status: 0,
    },
    size:{
      size:'',
      color_id:'',
      model_id:'',
      quantity:0,
      status:1
    },
    insumos: [],
    colors: [],
    sizes:[],
    purchases:[],
    purchase:{
      id: 0,
      purchase_id:0,
      inventory_id:0,
      quantity:0,
      price:0,
      total_price:0,
    },
    data: {},
    modal: {
      id:0,
      user_id: null,
      project_id: null,
      amount: "",
      status: "active"
    },
    modalEvidencia: [],
    suppliers: [],
    filteredSuppliers: [],
    modalAddSupplier: null,
    modalQuickInventory: null,
    newQuickProduct: {
      id: 0,
      name: '',
      ref: '',
      description: '',
      quantity: 0,
      price: 0,
      sale_price: 0,
      status: 1,
      bodega_id: '',
      low: 0,
      medium: 0,
      high: 0,
    },
    newSupplier: {
      name: '',
      email: '',
      phone: '',
      role: '5', // Proveedor
      status: 1,
      payment: '0',
    },
  };
},
components: { ArgonButton },
computed: {
  formattedPaymentPagado: {
    get() {
      return formatCurrencyInput(this.paymentModal.amount_pagado);
    },
    set(value) {
      this.paymentModal.amount_pagado = parseCurrencyInput(value);
    },
  },
  formattedQuickProductPrice: {
    get() {
      return formatCurrencyInput(this.newQuickProduct.price);
    },
    set(value) {
      this.newQuickProduct.price = parseCurrencyInput(value);
    },
  },
  formattedQuickProductSalePrice: {
    get() {
      return formatCurrencyInput(this.newQuickProduct.sale_price);
    },
    set(value) {
      this.newQuickProduct.sale_price = parseCurrencyInput(value);
    },
  },
  purchaseTotal() {
    const items = this.data?.data || [];
    return items.reduce((sum, item) => {
      const lineTotal = parseFloat(item.total_price ?? 0);
      if (lineTotal > 0) {
        return sum + lineTotal;
      }
      return sum + (parseFloat(item.quantity ?? 0) * parseFloat(item.price ?? 0));
    }, 0);
  },
  totalPagado() {
    return this.paymentsData.reduce((sum, payment) => sum + parseFloat(payment.amount_pagado ?? 0), 0);
  },
  diferenciaPendiente() {
    return Math.max(0, this.purchaseTotal - this.totalPagado);
  },
},
methods: {
  formatCurrencyInput,
  parseCurrencyInput,
  formatMoney(value) {
    return parseFloat(value ?? 0).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  },
  async getPayments() {
    if (!this.form.id) {
      this.paymentsData = [];
      return;
    }
    try {
      const response = await this.$store.dispatch('purchasesPayments/getData', this.form.id);
      this.paymentsData = response.data || [];
    } catch (error) {
      console.error('Error fetching payments:', error);
      this.paymentsData = [];
    }
  },
  resetPaymentModal() {
    this.paymentModal = {
      id: 0,
      purchase_id: this.form.id,
      payment_method: '',
      amount_pagado: 0,
    };
  },
  addPayment() {
    if (!this.form.id) {
      Swal.fire('Advertencia', 'Debe guardar la compra antes de registrar pagos.', 'warning');
      return;
    }
    this.resetPaymentModal();
    this.openPaymentModal();
  },
  editPayment(payment) {
    this.paymentModal = {
      id: payment.id,
      purchase_id: payment.purchase_id,
      payment_method: payment.payment_method,
      amount_pagado: parseFloat(payment.amount_pagado ?? 0),
    };
    this.openPaymentModal();
  },
  openPaymentModal() {
    const modalElement = document.getElementById('ModalPurchasePayment');
    this.modalPayment = new Modal(modalElement);
    this.modalPayment.show();
  },
  closePaymentModal() {
    if (this.modalPayment) {
      this.modalPayment.hide();
    }
    this.resetPaymentModal();
  },
  async submitPayment() {
    try {
      if (!this.paymentModal.payment_method) {
        Swal.fire('Error', 'Seleccione una forma de pago', 'error');
        return;
      }
      if (this.paymentModal.amount_pagado <= 0) {
        Swal.fire('Error', 'Ingrese el valor pagado', 'error');
        return;
      }
      this.paymentModal.purchase_id = this.form.id;
      const response = await this.$store.dispatch('purchasesPayments/save', this.paymentModal);
      if (response && response.status >= 200 && response.status < 300) {
        await this.getPayments();
        this.closePaymentModal();
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El pago ha sido guardado correctamente.',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } else {
        throw new Error(response?.data?.message || 'Error al guardar el pago');
      }
    } catch (error) {
      console.error('Error al guardar el pago:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Error al guardar el pago',
      });
    }
  },
  async deletePayment(paymentId) {
    try {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (result.isConfirmed) {
        const response = await this.$store.dispatch('purchasesPayments/delete', paymentId);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire('Eliminado!', 'El pago ha sido eliminado correctamente.', 'success');
          await this.getPayments();
        } else {
          throw new Error(response?.data?.message || 'Error al eliminar el pago');
        }
      }
    } catch (error) {
      console.error('Error al eliminar el pago:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Error al eliminar el pago',
      });
    }
  },
  formatSupplierLabel(user) {
    const name = (user?.name || '').trim() || 'Sin nombre';
    const document = (user?.document || '').trim();
    return document ? `${name} - ${document}` : name;
  },
  initSupplierSelect2() {
    if (!this.$refs.supplierSelect) return;
    const select = $(this.$refs.supplierSelect);
    if (select.hasClass('select2-hidden-accessible')) {
      select.select2('destroy');
    }
    select.off('change');
    select.select2({
      placeholder: 'Seleccione un proveedor',
      allowClear: true,
      width: '100%',
      containerCssClass: 'purchase-supplier-select2-container',
    });
    select.on('change', (e) => {
      this.form.supplier_id = e.target.value;
      this.selectSupplier();
    });
    if (this.form.supplier_id) {
      select.val(String(this.form.supplier_id)).trigger('change');
    }
  },
  async getSuppliers() {
    try {
      const response = await userService.getAll('all');
      const allUsers = response.data.data || response.data || [];
      this.suppliers = Array.isArray(allUsers) ? allUsers : [];
      this.$nextTick(() => {
        this.initSupplierSelect2();
      });
    } catch (error) {
      console.error('Error fetching suppliers:', error);
    }
  },
  selectSupplier() {
    const selectedSupplier = this.suppliers.find(s => s.id == this.form.supplier_id);
    if (selectedSupplier) {
      this.form.supplier = selectedSupplier.name;
      this.form.email = selectedSupplier.email || '';
      this.form.phone = selectedSupplier.phone || '';
    }
  },
  openAddSupplierModal() {
    const modalElement = document.getElementById('ModalAddSupplier');
    this.modalAddSupplier = new Modal(modalElement);
    this.modalAddSupplier.show();
  },
  closeAddSupplierModal() {
    if (this.modalAddSupplier) {
      this.modalAddSupplier.hide();
    }
    // Resetear formulario
    this.newSupplier = {
      name: '',
      email: '',
      phone: '',
      role: '5',
      status: 1,
      payment: '0',
    };
  },
  async saveSupplier() {
    try {
      if (!this.newSupplier.name?.trim()) {
        Swal.fire('Error', 'El nombre del proveedor es obligatorio', 'error');
        return;
      }

      const payload = {
        ...this.newSupplier,
        name: this.newSupplier.name.trim(),
        email: this.newSupplier.email?.trim() || null,
        phone: this.newSupplier.phone?.trim() || null,
      };

      const response = await userService.createUser(payload);
      
      if (response && response.status >= 200 && response.status < 300) {
        Swal.fire('Éxito', 'Proveedor creado correctamente', 'success');
        this.closeAddSupplierModal();
        // Recargar lista de proveedores
        await this.getSuppliers();
        // Seleccionar el proveedor recién creado
        this.form.supplier_id = response.data.id;
        this.$nextTick(() => {
          if (this.$refs.supplierSelect) {
            $(this.$refs.supplierSelect).val(String(this.form.supplier_id)).trigger('change');
          }
        });
        this.selectSupplier();
      } else {
        throw new Error(response?.data?.message || 'Error al crear el proveedor');
      }
    } catch (error) {
      console.error('Error creating supplier:', error);
      const errorMsg = error.response?.data?.message || error.message || 'Error al crear el proveedor';
      Swal.fire('Error', errorMsg, 'error');
    }
  },
  getIconClass(status) {
    if (status === 0) {
      return 'fa fa-circle'; // Ícono de clic
    } else if (status === 1) {
      return 'fa fa-check-circle text-success'; // Ícono de check verde
    } else if (status === 2) {
      return 'fa fa-times-circle text-danger'; // Ícono de X roja
    }
    return ''; // Devuelve una cadena vacía si no coincide con ningún estado
  },
  slugifyRef(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-zA-Z0-9-_]/g, '')
      .toUpperCase();
  },
  resetQuickProductForm() {
    this.newQuickProduct = {
      id: 0,
      name: '',
      ref: '',
      description: '',
      quantity: 0,
      price: 0,
      sale_price: 0,
      status: 1,
      bodega_id: '',
      low: 0,
      medium: 0,
      high: 0,
    };
  },
  openQuickInventoryModal() {
    this.resetQuickProductForm();
    const modalElement = document.getElementById('ModalQuickInventory');
    if (!this.modalQuickInventory) {
      this.modalQuickInventory = new Modal(modalElement);
    }
    this.modalQuickInventory.show();
  },
  closeQuickInventoryModal() {
    if (this.modalQuickInventory) {
      this.modalQuickInventory.hide();
    }
  },
  async refreshInsumosSelect(autoSelectId = null) {
    await this.getInsumos();
    await this.$nextTick();

    const $select = $(this.$refs.processesSelect);
    if (!$select.length) {
      return;
    }

    if ($select.hasClass('select2-hidden-accessible')) {
      $select.select2('destroy');
    }

    $select.empty();
    $select.append('<option value=""></option>');
    (this.insumos || []).forEach((item) => {
      $select.append(new Option(`${item.name} (${item.ref})`, item.id, false, false));
    });

    $select.select2({
      placeholder: 'Seleccione un insumo',
      allowClear: true,
      dropdownParent: $('#ModalBudget .modal-body'),
    });

    $select.off('change.purchaseInventory').on('change.purchaseInventory', () => {
      this.onInventorySelected($select.val());
    });

    if (autoSelectId) {
      $select.val(String(autoSelectId)).trigger('change');
    } else {
      $select.val(null).trigger('change');
    }
  },
  async saveQuickProduct() {
    const name = String(this.newQuickProduct.name || '').trim();
    if (!name) {
      await Swal.fire('Error', 'Ingrese el nombre del producto', 'error');
      return;
    }

    const ref = String(this.newQuickProduct.ref || '').trim() || this.slugifyRef(name);
    if (!ref) {
      await Swal.fire('Error', 'Ingrese la referencia del producto', 'error');
      return;
    }

    try {
      const payload = {
        ...this.newQuickProduct,
        id: 0,
        name,
        ref,
        quantity: 0,
        status: 1,
        price: parseFloat(this.newQuickProduct.price) || 0,
        sale_price: parseFloat(this.newQuickProduct.sale_price) || 0,
      };

      const response = await this.$store.dispatch('inventory/save', payload);
      if (response && response.status >= 200 && response.status < 300) {
        await this.getInsumos();
        this.closeQuickInventoryModal();

        await Swal.fire({
          icon: 'success',
          title: 'Producto guardado',
          text: 'El producto se agregó al inventario correctamente.',
          confirmButtonText: 'Aceptar',
        });
      } else {
        throw new Error(response?.data?.message || 'Error al crear el producto');
      }
    } catch (error) {
      console.error('Error al crear producto:', error);
      const errorMsg = error?.response?.data?.message || error?.message || 'Error al crear el producto';
      await Swal.fire('Error', errorMsg, 'error');
    }
  },
  resetPurchaseForm() {
    this.purchase = {
      id: 0,
      purchase_id: this.form.id || 0,
      inventory_id: 0,
      quantity: 0,
      price: 0,
      total_price: 0,
    };
  },
  async openModal() {
    this.resetPurchaseForm();
    const modalElement = document.getElementById('ModalBudget');
    if (!this.modalBudget) {
      this.modalBudget = new Modal(modalElement);
    }
    this.modalBudget.show();
    await this.refreshInsumosSelect();
  },
  async editDetail(row) {
    if (!row || this.form.status === 1) {
      return;
    }

    this.purchase = {
      id: row.id,
      purchase_id: this.form.id,
      inventory_id: row.inventory_id,
      quantity: parseInt(row.quantity, 10) || 0,
      price: parseFloat(row.price) || 0,
      total_price: parseFloat(row.total_price) || 0,
    };

    const modalElement = document.getElementById('ModalBudget');
    if (!this.modalBudget) {
      this.modalBudget = new Modal(modalElement);
    }
    this.modalBudget.show();
    await this.refreshInsumosSelect();

    await this.$nextTick();
    const $select = $(this.$refs.processesSelect);
    if ($select.length) {
      $select.val(String(row.inventory_id)).trigger('change.select2');
    }
  },
  closeModal() {
    if (this.modalBudget) {
      this.modalBudget.hide(); // Cierra el modal
    }
  },
  async getData() {
    await this.$store.dispatch('purchasesDetails/getData',this.form.id); 
    this.data =this.$store.state.purchasesDetails.getData;
  },
  async getInsumos() {
    const result = await this.$store.dispatch('inventory/getAll', { status: 1 });
    this.insumos = Array.isArray(result) ? result : (result?.data || []);
  },
  onInventorySelected(inventoryId) {
    const id = inventoryId ?? $(this.$refs.processesSelect).val();
    this.purchase.inventory_id = id || 0;

    if (!id) {
      this.purchase.price = 0;
      this.purchase.total_price = 0;
      return;
    }

    const item = this.insumos.find((i) => String(i.id) === String(id));
    if (!item) {
      return;
    }

    const purchasePrice = parseFloat(item.price) || 0;
    this.purchase.price = purchasePrice;
    this.updatePurchaseTotal();
    this.$nextTick(() => {
      const priceInput = document.getElementById('purchase_unit_price');
      const totalInput = document.getElementById('purchase_line_total');
      if (priceInput) {
        priceInput.value = formatCurrencyInput(this.purchase.price);
      }
      if (totalInput) {
        totalInput.value = formatCurrencyInput(this.purchase.total_price);
      }
    });
  },
  onPurchaseQuantityInput(event) {
    const digits = String(event.target.value).replace(/\D/g, '');
    this.purchase.quantity = digits === '' ? 0 : parseInt(digits, 10);
    this.updatePurchaseTotal();
    const totalInput = document.getElementById('purchase_line_total');
    if (totalInput) {
      totalInput.value = formatCurrencyInput(this.purchase.total_price);
    }
  },
  onPurchasePriceInput(event) {
    this.purchase.price = parseCurrencyInput(event.target.value);
    this.updatePurchaseTotal();
    event.target.value = formatCurrencyInput(this.purchase.price);
    if (this.purchase.quantity > 0) {
      const totalInput = document.getElementById('purchase_line_total');
      if (totalInput) {
        totalInput.value = formatCurrencyInput(this.purchase.total_price);
      }
    }
  },
  onPurchaseTotalInput(event) {
    this.purchase.total_price = parseCurrencyInput(event.target.value);
    const qty = parseInt(this.purchase.quantity, 10) || 0;
    if (qty > 0) {
      this.purchase.price = Math.round((this.purchase.total_price / qty) * 100) / 100;
    }
    event.target.value = formatCurrencyInput(this.purchase.total_price);
  },
  updatePurchaseTotal() {
    const qty = parseInt(this.purchase.quantity, 10) || 0;
    const price = parseFloat(this.purchase.price) || 0;
    this.purchase.total_price = Math.round(price * qty * 100) / 100;
  },
  async generatePdf() {
    if (!this.form.id) {
      await Swal.fire('Advertencia', 'Debe guardar la compra antes de generar el PDF.', 'warning');
      return;
    }

    try {
      const response = await this.$store.dispatch('purchases/getDoc', this.form.id);
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Compra_${String(this.form.id).padStart(4, '0')}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al generar PDF:', error);
      const msg = error?.data?.message || error?.response?.data?.message || 'No se pudo generar el PDF.';
      await Swal.fire('Error', msg, 'error');
    }
  },
  async confirm() {
    
    await Swal.fire({
          icon: 'info',
          title: 'Formalizar compra',
          text: 'Al formalizar la compra ya no se podra editar los registros ni los detalles de la compra y las cantidades se sumaran a inventario',
          confirmButtonText: 'Aceptar',
          backdrop: true,
      }).then((result) => {
          if (result.isConfirmed) {
            this.form.status = 1;
            this.save();
          }
      });
  },
  async save() {
    try {
      // Dispara la acción de Vuex para guardar el estudiante
      const response = await this.$store.dispatch("purchases/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
              this.form = response.data;
              this.form.id = response.data.id || 0;
              this.purchase.purchase_id = response.data.id || 0;
              await this.getPayments();
            }
        });

      }else{
        throw new Error(response.data.message || 'Error al guardar el proyecto');
      }

    } catch (error) {
      console.error("Error al crear el proyecto:", error);
      await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
      });
    }
  },  
  async submitForm() {
    try {
      const payload = {
        id: this.purchase.id || 0,
        purchase_id: this.form.id,
        inventory_id: this.purchase.inventory_id,
        quantity: parseInt(this.purchase.quantity, 10) || 0,
        price: this.purchase.price,
      };

      const response = await this.$store.dispatch("purchasesDetails/save", payload);
  
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: this.purchase.id
              ? 'El detalle de compra se actualizó correctamente.'
              : 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
              this.resetPurchaseForm();
              await this.getData();
              await this.getPayments();
              this.closeModal();
            }
        });
      }else{
        throw new Error(response.data?.message || 'Error al guardar el registro');
      }
      
    } catch (error) {
      console.error("Error al crear el registro:", error);
      await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
      });
    } 
  
  },
  async deleteRegister(userId) {
    try {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        const response = await this.$store.dispatch("purchasesDetails/delete", userId);
        if (response && response.status >= 200 && response.status < 300) {

          await Swal.fire(
            'Eliminado!',
            'El registro ha sido eliminado correctamente.',
            'success'
          );

          this.getData();
        } else {
          throw new Error(response.data.message || 'Error al eliminar el registro');
        }
      }
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Error al eliminar el registro',
      });
    }
  },

},
async mounted() {

  this.user = JSON.parse(localStorage.getItem('user'));

  const route = useRoute();
  const dataEdit = route.params.data;

  // Cargar proveedores primero para que estén disponibles al cargar la compra
  await this.getSuppliers();

  if (dataEdit) {
   
     

      try {
          const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear

          this.data = params;
          if (params && params.id) {

              this.purchase.purchase_id = params.id || 0;

              this.form.id = params.id || 0;
              // Convertir supplier_id a número si existe
              this.form.supplier_id = params.supplier_id ? parseInt(params.supplier_id) : '';
              this.form.supplier = params.supplier || '';
              this.form.phone = params.phone || '';
              this.form.email = params.email || '';
              this.form.description = params.description || '';
              this.form.status = params.status || 0;
            
              // Si hay supplier_id, seleccionar el proveedor después de que se carguen los proveedores
              this.$nextTick(() => {
                if (this.form.supplier_id && this.$refs.supplierSelect) {
                  $(this.$refs.supplierSelect)
                    .val(String(this.form.supplier_id))
                    .trigger('change.select2');
                }
                if (this.form.supplier_id) {
                  this.selectSupplier();
                }
              });
            
              await this.getData();
              await this.getPayments();
          }
      } catch (error) {
          console.error("Error al parsear los datos del registro:", error);
      }
  }

  await this.getInsumos();
  

  this.$store.state.isAbsolute = false;
  setNavPills();
  setTooltip();
},
beforeMount() {
  this.$store.state.imageLayout = "profile-overview";
  this.$store.state.showNavbar = true;
  this.$store.state.showFooter = true;
  this.$store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
},
beforeUnmount() {
  if (this.$refs.supplierSelect) {
    const select = $(this.$refs.supplierSelect);
    if (select.hasClass('select2-hidden-accessible')) {
      select.select2('destroy');
    }
  }
  this.$store.state.isAbsolute = false;
  this.$store.state.imageLayout = "default";
  this.$store.state.showNavbar = true;
  this.$store.state.showFooter = true;
  this.$store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
}
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  cursor: not-allowed;
}

.payment-summary-card {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 12px 14px;
  background: #f8f9fa;
}

.payment-summary-card--pending {
  border-color: #fb6340;
  background: #fff5f7;
}

.payment-summary-card--paid {
  border-color: #2dce89;
  background: #f0fff8;
}

.supplier-select-row :deep(.purchase-supplier-select2-container) {
  width: 100% !important;
}

.supplier-select-row :deep(.purchase-supplier-select2-container .select2-selection--single) {
  height: 31.5px !important;
  border: 1px solid #d2d6da !important;
  border-radius: 0.375rem !important;
}

.supplier-select-row :deep(.purchase-supplier-select2-container .select2-selection--single .select2-selection__rendered) {
  line-height: 29.5px !important;
  padding-left: 0.5rem !important;
  padding-right: 20px !important;
}

.supplier-select-row :deep(.purchase-supplier-select2-container .select2-selection--single .select2-selection__arrow) {
  height: 29.5px !important;
  right: 8px !important;
  top: 1px !important;
}

body.dark-version .payment-summary-card {
  border-color: rgba(255, 255, 255, 0.1);
  background: #2a2a2a;
}

body.dark-version .payment-summary-card--pending {
  border-color: #fb6340;
  background: #3a2020;
}

body.dark-version .payment-summary-card--paid {
  border-color: #2dce89;
  background: #1a3a2a;
}
</style>


